import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import styles from "./Campaign.module.css";
import LoginDivOnly from "../../components/LoginDivOnly/LoginDivOnly";
import TCModalTournament from "../../components/Modal/TCModalTournament/TCModalTournament";
import OtpModal from "../../components/Modal/OtpModal/OtpModal";
import PaymentLoadingModal from "../../components/Modal/PaymentLoadingModal/PaymentLoadingModal";

const Campaign = ({ subscriptionType, campaignPageNumber, bannerImgSrc, loginPlacement = "center" }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { playerData } = useContext(dataContext);
  const [activeBottom, setActiveBottom] = useState("campaign");
  const [showLoginModalCampaign, setShowLoginModalCampaign] = useState(loginPlacement === "bottom");
  const [showTCModalTournament, setShowTCModalTournament] = useState(false);
  const [showPaymentLoadingModal, setShowPaymentLoadingModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [toggleToUpdate, setToggleToUpdate] = useState(false);

  const campaignId = searchParams.get("qcid");

  useEffect(() => {
    // Redirect if no campaign ID
    if (!campaignId) {
      navigate("../");
      return;
    }
    sessionStorage.setItem('cid', campaignId);

    // Handle login div
    let timer;
    if (loginPlacement !== "bottom") {
      timer = setTimeout(() => {
        setShowLoginModalCampaign(true);
      }, 3000);
    }

    // activity logs
    const msisdn = playerData?.msisdn ?? null;
    activityLogSubmission("campaign", msisdn);
    activityLogSubmission(`campaign${campaignPageNumber}`, msisdn);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  const otpFlowModals = (
    <>
      {showOtpModal && (
        <OtpModal
          activeBottom={activeBottom}
          showOtpModal={showOtpModal}
          setShowOtpModal={setShowOtpModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
        ></OtpModal>
      )}
      {showPaymentLoadingModal && (
        <PaymentLoadingModal
          showPaymentLoadingModal={showPaymentLoadingModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
          activeBottom={activeBottom}
          toggleToUpdate={toggleToUpdate}
          setToggleToUpdate={setToggleToUpdate}
        ></PaymentLoadingModal>
      )}
      <TCModalTournament
        showTCModalTournament={showTCModalTournament}
        setShowTCModalTournament={setShowTCModalTournament}
      ></TCModalTournament>
    </>
  );

  if (loginPlacement === "bottom") {
    return (
      <>
        <div className={styles.landingPageOuter}>
          <div className={styles.landingWrapper}>
            <img src={bannerImgSrc} loading="lazy" alt="Campaign Banner" className={styles.landingImgResponsive} />
            <div className={styles.loginOverlay}>
              {showLoginModalCampaign && <LoginDivOnly
                activeBottom={activeBottom}
                setActiveBottom={setActiveBottom}
                setShowLoginModalCampaign={setShowLoginModalCampaign}
                setShowOtpModal={setShowOtpModal}
                showOtpModal={showOtpModal}
                setShowTCModalTournament={setShowTCModalTournament}
                subscriptionType={subscriptionType}
                placement="bottom"
              ></LoginDivOnly>}
            </div>
          </div>
        </div>
        {otpFlowModals}
      </>
    );
  }

  return (
    <>
      <div className={`${styles.landingPage}`}>
        <img src={bannerImgSrc} loading="lazy" alt="Campaign Banner" className={styles.landingImg} onClick={() => {
          setShowLoginModalCampaign(true)
        }} />
        {showLoginModalCampaign && <LoginDivOnly
          activeBottom={activeBottom}
          setActiveBottom={setActiveBottom}
          setShowLoginModalCampaign={setShowLoginModalCampaign}
          setShowOtpModal={setShowOtpModal}
          showOtpModal={showOtpModal}
          setShowTCModalTournament={setShowTCModalTournament}
          subscriptionType={subscriptionType}
        ></LoginDivOnly>}
        {otpFlowModals}
      </div>
    </>
  );
};

export default Campaign;
